import { render, staticRenderFns } from "./project-monitor.vue?vue&type=template&id=f0839b6c&scoped=true&"
import script from "./project-monitor.vue?vue&type=script&lang=js&"
export * from "./project-monitor.vue?vue&type=script&lang=js&"
import style0 from "./project-monitor.vue?vue&type=style&index=0&id=f0839b6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0839b6c",
  null
  
)

export default component.exports